_ =  require('lodash')

AccountService = ($rootScope, $http, $q, $location, $filter, $translate, cache, flash) ->

  $rootScope.$on 'signedIn.gnp.authService', ->
    getUserInfo()

  $rootScope.$on 'signedOut.gnp.authService', ->
    removeUserInfo()

  $rootScope.$on 'accountUpdated.gnp.AccountService', ->
    removeUserInfo()
    getUserInfo()

  getFullName = (data) ->
    #For the case in App does not require to enter first_name, last_name
    #So that first_name or last_name will be null
    return $filter('translate')('ACCOUNT.NO_NAME') unless data.last_name
    return $filter('translate')('ACCOUNT.NO_NAME') unless data.first_name

    if /^ja/i.test $translate.preferredLanguage()
      "#{data.last_name} #{data.first_name}"
    else
      "#{data.first_name} #{data.last_name}"

  removeUserInfo = ->
    cache.remove('userInfo')

  getUserInfo = ->
    userInfo = cache.get('userInfo')
    delay = $q.defer()
    unless userInfo
      $http.get('/api/settings/account.json').then(
        (resp) ->
          mergedData = _.merge resp.data,
            name: getFullName(resp.data)
          cache.put('userInfo', mergedData)
          delay.resolve mergedData
          $rootScope.$broadcast 'accountLoaded.gnp.AccountService', mergedData
        (error) ->
          delay.resolve null
      )
    else
      delay.resolve userInfo
    delay.promise

  acceptTerms = ->
    delay = $q.defer()
    $http.put('/api/settings/account/terms_of_use.json').success (data) ->
      userInfo = cache.get('userInfo')
      userInfo.has_accept_terms_of_use = true
      cache.put('userInfo', userInfo)
      delay.resolve null
    .error (data) ->
        delay.resolve null
    delay.promise


  setConfirmationStatus = ->
    userInfo = cache.get('userInfo')
    if userInfo
      userInfo.email_confirmed = true
      cache.put('userInfo', userInfo)

  showConfirmationWarning = () ->
    notDisplayPaths = ['/email_confirmation/new', '/email_confirmation/edit']
    notShowed = _.remove(notDisplayPaths, (n) -> $location.path().indexOf(n) != -1).length > 0
    return if notShowed

    userInfo = cache.get('userInfo')
    return if userInfo?.email_confirmed

    options =
      timeOut: '0'
      extendedTimeOut: '0'
      tapToDismiss: false
      onShown: ->
        $this = angular.element(this)
        $this.on 'click', ->
          $location.path('/email_confirmation/new')
          $this.remove()

    flash.warning """
      <a href="/email_confirmation/new">
      #{$filter('translate')('_CONFIRMATION.NOTIFICATION.TEXT')}
      </a>
    """, options

  getUserInfo: getUserInfo
  showConfirmationWarning: showConfirmationWarning
  setConfirmationStatus: setConfirmationStatus
  acceptTerms: acceptTerms

AccountService.$inject = [
  '$rootScope'
  '$http'
  '$q'
  '$location'
  '$filter'
  '$translate'
  'cache'
  'flash'
]

module.exports = AccountService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/account/account-service.coffee